import { ArrowRight, BarChart3, BookOpen, TrendingUp, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function UnlockYourFinancialFutureWithOurExpertCourses() {
  const courses = [{
    id: 1,
    title: "Fundamentos de la Bolsa de Valores",
    description: "Aprende los conceptos básicos del mercado estadounidense y cómo funcionan las acciones.",
    icon: BookOpen,
    duration: "8 semanas",
    level: "Principiante"
  }, {
    id: 2,
    title: "Análisis Técnico Avanzado",
    description: "Domina las herramientas de análisis técnico para identificar oportunidades de inversión.",
    icon: BarChart3,
    duration: "10 semanas",
    level: "Intermedio"
  }, {
    id: 3,
    title: "Estrategias de Inversión",
    description: "Desarrolla estrategias efectivas para maximizar tus rendimientos en el mercado.",
    icon: TrendingUp,
    duration: "12 semanas",
    level: "Avanzado"
  }];
  const benefits = [{
    id: 1,
    text: "Instrucción de expertos en el mercado estadounidense"
  }, {
    id: 2,
    text: "Enfoque práctico y actualizado"
  }, {
    id: 3,
    text: "Acceso a recursos y herramientas profesionales"
  }, {
    id: 4,
    text: "Testimonios de éxito de estudiantes"
  }];
  return <section className="relative bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="mx-auto max-w-3xl text-center mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6 tracking-wide">Desbloquea Tu Futuro Financiero Con Nuestros Cursos Expertos</h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">Zafiro Investment te ofrece formación especializada en el mercado de valores estadounidense, diseñada para hispanohablantes que buscan invertir con confianza y conocimiento.</p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16">
          {courses.map((course, i) => {
          const Icon = course.icon;
          return <Card key={course.id} data-index={i} className="hover-lift border border-border shadow-soft bg-surface">
                <CardHeader>
                  <div className="flex items-center justify-center w-14 h-14 rounded-md bg-primary/10 mb-4">
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {course.title}
                  </CardTitle>
                  <CardDescription className="text-muted-foreground">
                    {course.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1.5">
                      <BookOpen className="w-4 h-4" />
                      {course.duration}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Users className="w-4 h-4" />
                      {course.level}
                    </span>
                  </div>
                </CardContent>
                <CardFooter>
                  <Link to="/CursosPage" className="w-full">
                    <Button variant="outline" className="w-full group">
                      Ver Detalles
                      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </Button>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>

        {}
        <Card className="border border-border shadow-soft bg-surface">
          <CardHeader>
            <CardTitle className="text-2xl font-semibold text-foreground text-center">¿Por Qué Elegir Zafiro Investment?</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {benefits.map((benefit, i) => <div key={benefit.id} data-index={i} className="flex items-start gap-3 p-4 rounded-md bg-background hover:bg-accent/5 transition-colors duration-medium">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-0.5">
                    <div className="w-2 h-2 rounded-full bg-secondary" />
                  </div>
                  <p className="text-foreground leading-relaxed">{benefit.text}</p>
                </div>)}
            </div>
          </CardContent>
          <CardFooter className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/CursosPage">
              <Button size="lg" className="group">
                Explorar Todos los Cursos
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/ContactoPage">
              <Button size="lg" variant="outline">
                Contáctanos
              </Button>
            </Link>
          </CardFooter>
        </Card>
      </div>
    </section>;
}